import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, distinctUntilChanged, map, merge, of, switchMap } from 'rxjs';
import { RankingsApiService } from '../rankings-api.service';
import {
	fetchRankingsList,
	loadStateRankingsFailure,
	updateRankingsList,
} from './rankings-category.actions';

@Injectable()
export class StateRankingsCategoryEffects {
	constructor(
		private readonly _actions$: Actions,
		private _rankingsApiSrv: RankingsApiService,
	) {}

	fetchRankings = createEffect(() =>
		this._actions$.pipe(
			ofType(fetchRankingsList),
			distinctUntilChanged(),
			switchMap(({ category, rankingType }) =>
				merge(
					of(null),
					this._rankingsApiSrv.getUniversityRankings(category, rankingType),
				),
			),
			map((response) => updateRankingsList(response)),
			catchError((error) => of(loadStateRankingsFailure(error))),
		),
	);
}
